import React from 'react';
import { usePushNotifications } from '../hooks/usePushNotifications';
import { toast } from 'sonner';
import './NotificationSettings.css';

export default function NotificationSettings() {
  const { 
    isSupported, 
    isSubscribed, 
    permission, 
    loading, 
    subscribe, 
    unsubscribe 
  } = usePushNotifications();

  const handleToggle = async () => {
    if (isSubscribed) {
      const result = await unsubscribe();
      if (result.success) {
        toast.success('Push notifications disabled');
      } else {
        toast.error('Failed to disable notifications');
      }
    } else {
      const result = await subscribe();
      if (result.success) {
        toast.success('Push notifications enabled! You\'ll receive updates on payments and announcements.');
      } else if (result.error === 'Permission denied') {
        toast.error('Please allow notifications in your browser settings');
      } else {
        toast.error('Failed to enable notifications');
      }
    }
  };

  if (!isSupported) {
    return (
      <div className="notification-settings not-supported">
        <div className="notification-icon">🔔</div>
        <div className="notification-info">
          <h4>Push Notifications</h4>
          <p>Not supported in this browser</p>
        </div>
      </div>
    );
  }

  return (
    <div className="notification-settings">
      <div className="notification-icon">
        {isSubscribed ? '🔔' : '🔕'}
      </div>
      <div className="notification-info">
        <h4>Push Notifications</h4>
        <p>
          {isSubscribed 
            ? 'You\'ll receive instant updates' 
            : 'Get notified about payments & updates'}
        </p>
      </div>
      <button 
        className={`notification-toggle ${isSubscribed ? 'active' : ''}`}
        onClick={handleToggle}
        disabled={loading || permission === 'denied'}
        data-testid="push-notification-toggle"
      >
        {loading ? 'Loading...' : isSubscribed ? 'Enabled' : 'Enable'}
      </button>
      {permission === 'denied' && (
        <p className="permission-warning">
          Notifications blocked. Enable in browser settings.
        </p>
      )}
    </div>
  );
}
